import { cn } from '@/lib/cn'

type Status = 'ok' | 'running' | 'success' | 'error' | 'failure' | 'warning' | 'pending' | 'unknown'

const statusStyles: Record<Status, string> = {
  ok: 'bg-green-500/10 text-green-400 border-green-500/30',
  running: 'bg-green-500/10 text-green-400 border-green-500/30',
  success: 'bg-green-500/10 text-green-400 border-green-500/30',
  error: 'bg-red-500/10 text-red-400 border-red-500/30',
  failure: 'bg-red-500/10 text-red-400 border-red-500/30',
  warning: 'bg-yellow-500/10 text-yellow-400 border-yellow-500/30',
  pending: 'bg-blue-500/10 text-blue-400 border-blue-500/30',
  unknown: 'bg-gray-500/10 text-gray-400 border-gray-500/30',
}

export function StatusBadge({ status, label }: { status: string; label?: string }) {
  const key = (status?.toLowerCase() ?? 'unknown') as Status
  const style = statusStyles[key] ?? statusStyles.unknown

  return (
    <span className={cn('inline-flex items-center gap-1.5 px-2 py-0.5 text-xs font-medium rounded border', style)}>
      <span className={cn(
        'w-1.5 h-1.5 rounded-full',
        key === 'ok' || key === 'running' || key === 'success' ? 'bg-green-400' :
        key === 'error' || key === 'failure' ? 'bg-red-400' :
        key === 'warning' ? 'bg-yellow-400' :
        key === 'pending' ? 'bg-blue-400' : 'bg-gray-400'
      )} />
      {label ?? status}
    </span>
  )
}
